@if (formRef) {
  <div class="radio-container" [formGroup]="formRef">
    <h4>Preferred method of contact:</h4>
    <mat-radio-group
      class="default-contact-options"
      formControlName="preferredContactMethod"
      aria-label="Select an option"
      (change)="onRadioChange()"
    >
      @if (reporter.Email) {
        <mat-radio-button class="contact-radio" value="email" checked>
          <div class="custom-icon email"></div>
          <div class="custom-icon email_dark"></div>
          {{ reporter.Email }}
        </mat-radio-button>
      }
      @if (reporter.Phone) {
        <mat-radio-button class="contact-radio" value="phone">
          <div class="custom-icon phone"></div>
          <div class="custom-icon phone_dark"></div>
          {{ reporter.Phone | phoneNumber: 'US' }}
        </mat-radio-button>
      }
      @if (reporter.Phone && altContact) {
        <mat-radio-button #alternatePhoneRadioButton class="contact-radio" value="Alternate Phone">
          <div class="custom-icon phone"></div>
          <div class="custom-icon phone_dark"></div>
          <mat-form-field class="country-select">
            <mat-label>Country</mat-label>
            <mat-select formControlName="countryCode" id="countryCode">
              @for (countryCode of countryCodes; track countryCode.iso2) {
                <mat-option [value]="countryCode.iso2">
                  {{ countryCode.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="alt-phone" (click)="selectAlternatePhoneRadioButton()">
            <mat-label>Alternate Phone</mat-label>
            <input
              matInput
              type="tel"
              placeholder="Alt. Phone"
              formControlName="alternatePhone"
              id="alternatePhone"
              (keypress)="altPhoneKeypress($event)"
            />
          </mat-form-field>
        </mat-radio-button>
      }
    </mat-radio-group>

    @if (formRef.errors?.['isValidPhoneNumber']) {
      <div class="form-error">
        <div class="custom-icon inline_error"></div>
        <div class="error-message">Invalid alternate phone number.</div>
      </div>
    }
  </div>
}